package top.wcpe.allincore.ui.runtime.ir.prop

import top.wcpe.allincore.ui.runtime.element.UIElement
import top.wcpe.allincore.ui.runtime.internal.log.UiLog
import kotlin.jvm.JvmStatic

/**
 * 属性写入诊断辅助。
 *
 * 各 `*PropContributor` 在遇到"不支持在 X 上设置 Y"时通过本类输出 WARN，
 * 自动附带 [PropApplyContext] 中由 [PropAppliers.apply] 入栈的 screen / element 标签，
 * 便于定位 DSL 源头。
 */
internal object PropDiag {

    /** 输出"不支持在 X 上设置 Y"WARN，附带当前 [PropApplyContext] 标签。 */
    @JvmStatic
    fun unsupported(logger: UiLog, el: UIElement<*>?, propName: String) {
        val location = PropApplyContext.currentLabel()
        val elName = el?.let { it::class.simpleName } ?: "?"
        if (location.isEmpty()) {
        }
    }
}
